import { defineAction } from '~/prix'
import { z } from 'zod'
import complementaryRoadFetchAction from './complementaryRoadFetch.action.json' with { type: 'json' }
import { complementaryRoadObject } from '../complementaryRoadObject'

const complementaryRoadFetchDefinition = defineAction({
  ...complementaryRoadFetchAction,
  input: z.object({
    id: complementaryRoadObject.shape.id,
  }),
  output: complementaryRoadObject,
})

export default complementaryRoadFetchDefinition
